import styled from "styled-components";
import {flexRowContainerMixin} from "../../../../themes/architecture/css-helpers/flex";

export const JackpotToastTimeAndAmountDefaultBox = styled.div`
    ${flexRowContainerMixin};
    align-items: center;
    width: 43rem;
    max-width: 100%;
    min-height: 53px;
    @media ${props => props.theme.mediaQuery.mAndBelow} {
        min-height: 38px;
        width: 31rem;
        border-radius: 1.2rem;
    }
    border-radius: 1.6rem;
    background-color: ${props => props.theme.colors.backgroundMiddleDark};
    box-shadow: inset 0 0 4px 4px black;
    border: 1px solid ${props => props.theme.colors.boxBorderLight};
    margin: 0.8rem auto 0;
`;